module.exports = __webpack_public_path__ + "static/media/bronze_marker.169857aa.svg";